import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import { ROUTE_CAMPAIGN_REGISTER } from '~/components/router/constants.js';
import useCasinoRoutes from '~/components/router/use-casino-routes';
import Header from '~/components/header/header.js';
import IngameDesktopHeader from '~/components/header/ingame-desktop-header/index.js';
import { selectIsDesktop } from '~/components/brand/ducks/selectors.js';
import RightContainerHeader from '~/components/header/right-container-header.js';

const RoutesHeader = () => {
	const isDesktop = useSelector(selectIsDesktop);
	const { ROUTE_CASINO_GAME, ROUTE_LIVE_CASINO_GAME } = useCasinoRoutes();
	const PATHS_WITH_INGAME_HEADER = useMemo(() => {
		return [...(isDesktop ? [ROUTE_LIVE_CASINO_GAME, ROUTE_CASINO_GAME] : [])];
	}, [ROUTE_CASINO_GAME, ROUTE_LIVE_CASINO_GAME, isDesktop]);
	return (
		<TracedRoutes>
			<Route path="/" exact />
			<Route path={ROUTE_CAMPAIGN_REGISTER} />
			{PATHS_WITH_INGAME_HEADER.map(path => (
				<Route
					path={`${path}/*`}
					key={path}
					element={<IngameDesktopHeader RightContainerHeader={RightContainerHeader} isInGame="true" />}
				/>
			))}
			<Route
				path="*"
				element={
					<Header>
						<RightContainerHeader />
					</Header>
				}
			/>
		</TracedRoutes>
	);
};

export default RoutesHeader;
